<div class="clear"></div>
<footer class="footer-wrapper">
    <hr class="footer-line" />
    <div class="footer-content">
        <div class="pull-left small-12">
            <span class="footer-content-txt">
        {{'footercontent' | translate}}
      </span>
        </div>
        <!-- <div class="pull-right">
            <a aria-label="Star Alliance Member" [ngClass]="{'disable-pointer':isPaymentPage}" class="icon-star-alliance pull-right text-white" [href]="getLink()" target="{{isPaymentPage ? '' : '_blank'}}">
                <span class="sr-only">
          <span>Star Alliance Member</span>
                </span>
            </a>
        </div> -->
    </div>
</footer>